import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';
import { ResponseContentType } from '@angular/http';

@Injectable()
export class PDFService {
    constructor(private http: HttpClient) {
    }
    getPDF(data, namePDF) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.put(Constants.URL_BACKEND + '/attachment/pdf/' + namePDF, data, { headers: headers, responseType: 'blob' });
    }
    getPDFRetencion(data, namePDF) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
        return this.http.post(Constants.URL_BACKEND + '/descargar-retencion/' + namePDF + '/'+ data, {}, { headers: headers, responseType: 'blob' });
    }

}



// WEBPACK FOOTER //
// ./src/app/system/services/pdf.service.ts